import { c } from '../../../utils/tailwind-merge';
import {
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
} from '../../molecules/Tabs/Tabs';
import { PublisherLists } from '../PublisherLists/PublisherLists';

import { PublisherProfileTabsProps } from './PublisherProfileTabs.types';

export const PublisherProfileTabs = ({
  renderPublisherAssets,
  lists,
  microcopy,
  value,
  defaultValue,
  className,
}: PublisherProfileTabsProps) => {
  return (
    <section className={c('min-h-116 w-full', className)}>
      <TabsRoot value={value} defaultValue={defaultValue}>
        <TabsList>
          <TabsTrigger value="assets" data-testid="tabs-trigger-assets">
            {microcopy.tabs.assets}
          </TabsTrigger>
          <TabsTrigger value="lists" data-testid="tabs-trigger-lists">
            {microcopy.tabs.lists}
          </TabsTrigger>
        </TabsList>

        <TabsContent
          value="assets"
          forceMount={true}
          data-testid="tabs-content-assets"
        >
          {renderPublisherAssets()}
        </TabsContent>
        <TabsContent
          value="lists"
          forceMount={true}
          data-testid="tabs-content-lists"
        >
          <PublisherLists {...lists} microcopy={{ ...microcopy.lists }} />
        </TabsContent>
      </TabsRoot>
    </section>
  );
};
